import React, { Component, Fragment } from 'react';

export default class InitialSelector extends Component {

    constructor(props) {
        super(props);
        this.state = {
            choice: {
                id: -99,
                name: 'none',
                promptForAddress: false
            },
            is_curbside_order: false
        };
        this.setServiceType = this.setServiceType.bind(this);
        this.chooseServiceType = this.chooseServiceType.bind(this);
        this.curbside = this.curbside.bind(this);
    }

    setServiceType() {
         this.props.selectServiceType(this.state.choice, this.state.is_curbside_order);
    }

    chooseServiceType(val) {
        this.setState({choice: val}, ()=> {
            this.setServiceType();
        });
    }

    render_icon(service_type)
    {
        if(service_type === 1)
        {
            return 'fas fa-car store-fg-secondary';
        }
        if(service_type === 3)
        {
            return 'fas fa-walking store-fg-secondary';
        }
        else
        {
            return null;
        }
    }

    curbside(st) {
        this.setState({
            is_curbside_order: true
        }, () => {
            this.chooseServiceType(st);
        })
    }

    render() {
        let serviceTypeButtons = this.props.serviceTypes ? this.props.serviceTypes.map( (val, ind, arr) => {
            let selectorFunc = () => {
                this.chooseServiceType(val);
            };
            let curbsideSelectorFunc = () => {
                this.curbside(val);
            };
            let isActive = this.state.choice.id === val.id;
            if(window.session.store.has_curbside && val.pos_id === 3) {
                return(
                    <div key={ind} className={"d-inline"}>
                        <a onClick={selectorFunc} className={`btn ${isActive ? 'btn-accent' :'btn-primary'} m-2 d-inline`}>
                            <i className={this.render_icon(val.pos_id)} />
                            {` ${val.name}`}
                        </a>
                        <a onClick={curbsideSelectorFunc} className={`btn btn-sm ${isActive ? 'btn-accent' :'btn-primary'} m-2`}>
                            <i className={"fas fa-check-circle store-fg-secondary"} />
                            {` ${window.session.store.curbside_title}`}
                        </a>
                    </div>
                )
            }
            else {
                return <a onClick={selectorFunc} key={ind} className={`btn ${isActive ? 'btn-accent' :'btn-primary'} m-2 d-inline`}>
                    <i className={this.render_icon(val.pos_id)} />
                    {` ${val.name}`}
                </a>
            }
        }) : '';
        let showButton = this.state.choice.id != -99;
        let isAlreadySet = window.session.service_type_id;
        return (
            <Fragment>
                <div className="text-center">
                <div className="modal-header">
                    <h5 className="modal-title">Please Select A Service Type.</h5>
                </div>
                    <small className="font-weight-bold">{session.delivery_wait_time && `Delivery: ${session.delivery_wait_time} minutes`} | {session.pickup_wait_time && `Pickup: ${session.pickup_wait_time} minutes`}</small>
                </div>
            <div className="modal-body text-center">
            {!this.props.showAddressSelector &&
                serviceTypeButtons
            }
            {
                this.props.showAddressSelector &&
                    this.props.addressSelector
            }
            </div>
            {/*<div className="w-100 clear">*/}
                {/*{isAlreadySet ? <button onClick={this.props.hideSelector} className='btn btn-secondary m-3 place-right'>Cancel</button> : '' }*/}
                {/*{isAlreadySet ? <button onClick={this.props.hideSelector} className='btn btn-primary m-3 float-right'>Done</button> : '' }*/}
            {/*</div>*/}
            </Fragment>
        );
    }
}